"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OffCanvasStatus = exports.BC_OFF_CANVAS_SAFARI_REGEX = exports.VISIBLE_OVERFLOW = exports.OFF_CANVAS_BUTTONS_QUERY = exports.OFF_CANVAS_SELECTOR_ASIDE = exports.OFF_CANVAS_TAB = exports.OFF_CANVAS_STATUS_TYPE = exports.OFF_CANVAS_CLOSE_BUTTON_TEXT = exports.OFF_CANVAS_STATUS_PROPERTY = exports.OFF_CANVAS = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
exports.OFF_CANVAS = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-off-canvas");
exports.OFF_CANVAS_STATUS_PROPERTY = 'status';
exports.OFF_CANVAS_CLOSE_BUTTON_TEXT = 'error';
exports.OFF_CANVAS_STATUS_TYPE = 'type';
exports.OFF_CANVAS_TAB = 'Tab';
exports.OFF_CANVAS_SELECTOR_ASIDE = 'aside';
exports.OFF_CANVAS_BUTTONS_QUERY = ':scope>aside>section:first-child>button:first-child';
exports.VISIBLE_OVERFLOW = 'visible';
exports.BC_OFF_CANVAS_SAFARI_REGEX = /^((?!chrome|android).)*safari/i;
var OffCanvasStatus;
(function (OffCanvasStatus) {
    OffCanvasStatus["close"] = "close";
    OffCanvasStatus["open"] = "open";
})(OffCanvasStatus || (exports.OffCanvasStatus = OffCanvasStatus = {}));
